import {
  AtSymbolIcon,
  PhoneIcon,
  UserGroupIcon,
  WifiIcon,
} from "@heroicons/react/outline";
import { auth } from "../../database/firebase";

const HomepageIntro = () => {
  return (
    <div className="lg:fixed lg:top-28">
      <div className="bg-white w-[40rem] rounded-md border border-gray-100 shadow">
        <div className="py-4 px-2 border-b-2 border-gray-300">
          <h1>How to use memento ?</h1>
        </div>
        <div className="grid place-items-center py-10">
          <img src="/images/Dashboard.svg" alt="just" className="h-40" />
        </div>

        <div className="flex items-center justify-center space-x-7 py-5">
          <PhoneIcon className="about__icons" />
          <AtSymbolIcon className="about__icons" />
          <WifiIcon className="about__icons" />
          <UserGroupIcon className="about__icons" />
        </div>
      </div>
      <div className="flex px-5 justify-between pt-8 text-base font-semibold text-green-500 cursor-pointer">
        <p>Disclaimer</p>
        <p>Privacy</p>
        <p>Terms</p>
        <p>About</p>
        <p onClick={() => auth.signOut()}>Logout</p>
      </div>
    </div>
  );
};

export default HomepageIntro;
